import { BASE_URL, getToken } from './client';

export const backupApi = {
  export: async (): Promise<string> => {
    const url = `${BASE_URL}/backup/export`;
    const headers: Record<string, string> = { Accept: 'application/json' };
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const response = await fetch(url, { headers, credentials: 'include' });
    if (!response.ok) throw new Error(`Export failed: ${response.statusText}`);
    return await response.text();
  },
};
